(function(){
"use strict";
var doc=document, root=doc.documentElement;
var reduced=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
doc.documentElement.classList.remove("no-js"); doc.documentElement.classList.add("js");
/* ---------------------------------------------------------- CODE BUILDER */
(function(){
  var out=doc.getElementById("codeOut"); if(!out) return;
  var tEl=doc.getElementById("codeTitle"), dEl=doc.getElementById("codeDesc"),
      oEl=doc.getElementById("codeObj"), aEl=doc.getElementById("codeAct");
  /* Where a built code goes when the reader wants the whole protocol.
     One constant: change this line and every state of the button follows.
     The code travels as a query parameter, so the destination stays a single
     page until per-code URLs exist. */
  var PROFILE_BASE="https://dermalhealth.store/products/";
  var moreEl=doc.getElementById("codeMore"), moreLbl=doc.getElementById("codeMoreLbl");
  function setMore(code){
    if(!moreEl) return;
    moreEl.href=PROFILE_BASE+""+encodeURIComponent(code);
    if(moreLbl) moreLbl.textContent=code;
    moreEl.setAttribute("aria-label","More on the "+code+" profile");
  }

  var state={age:{v:"adult",w:"adult"}, hyd:{v:"D",w:"dry"}, pig:{v:"P",w:"pigmentation"},
             inf:{v:"B",w:"breakouts"}, teen:{v:"HEALTHY",w:"healthy skin"}};

  var frag={
    D:{d:"Your barrier is under-supplied — too little water held, too little lipid holding it. Everything else you treat will be felt more sharply because of it.",
       o:["Physiological barrier repair","Restore water-holding capacity"], a:["Ceramides","Cholesterol","Fatty acids","Hyaluronic acid","d-Panthenol"]},
    O:{d:"Sebum is running ahead of what the follicle can clear, which changes both how the skin feels and how readily it congests.",
       o:["Regulate sebum output","Keep the follicle patent"], a:["Salicylic acid","Zinc PCA","Niacinamide"]},
    P:{d:"Pigment is being manufactured in the wrong places — which means there is a production line to interrupt, at four separate points, rather than a stain to lift.",
       o:["Inhibit melanin synthesis","Interrupt melanosome transfer","Daily photoprotection"], a:["Azelaic acid","Alpha arbutin","Niacinamide","Bakuchiol","SPF 50"]},
    B:{d:"Breakouts with the full picture behind them: the plug, the sebum, the microbial pressure and the inflammation, all running at once.",
       o:["Unclog the follicle","Reduce inflammatory signalling","Control microbial pressure"], a:["Salicylic acid","Niacinamide","Zinc PCA","Retinoid ester (HPR)"]},
    BM:{d:"Congestion more than inflammation — comedones, occasional papules, and a follicle that needs keeping open rather than calming down.",
       o:["Normalise follicular keratinisation","Prevent progression to inflammatory lesions"], a:["Salicylic acid","Retinoid ester (HPR)","Niacinamide"]},
    BF:{d:"Uniform, often itchy lesions alongside the usual pattern — the signature of Malassezia. Treated on both pathways at once, because both are present.",
        o:["Reduce yeast load in the follicle","Unclog the follicle","Reduce inflammation"], a:["Zinc pyrithione","Salicylic acid","Niacinamide"]},
    R:{d:"Flushing and facial redness. Not everyone here has true rosacea, but everyone here flushes — and flushing is worth treating early.",
       o:["Reduce inflammatory mediators","Support vessel integrity","Rebuild tolerance"], a:["4-Ethoxybenzaldehyde","Vitamin K1","Azelaic acid","Zinc pyrithione"]},
    A:{d:"A history of scaling, redness or irritation to things that are not usually irritants — most often an impaired barrier reacting on your behalf.",
       o:["Repair the barrier first","Reduce reactivity before adding actives"], a:["Ceramides","Medilan™ lanolin","Niacinamide","d-Panthenol"]},
    S:{d:"Skin that stings and burns on contact with products, wind, cold or heat — usually without the flushing that accompanies rosacea.",
       o:["Lower the reaction threshold","Introduce actives only on proven tolerance"], a:["d-Panthenol","Niacinamide","Hyaluronic acid","Medical-grade aloe"]},
    AGE:{d:"Above twenty, the ageing pathway is always part of the plan: collagen declining about a percent a year, and photodamage accumulating faster than repair.",
       o:["Protect and rebuild the matrix","Daily photoprotection"], a:["Retinoid ester (HPR)","THDA vitamin C","Peptides","SPF 50"]}
  };

  /* The under-20 pathway is not a composed code — it is a severity ladder of
     named profiles. Titles, wording and actives follow the real TEEN-* library. */
  var teenFrag={
    "HEALTHY":{c:"TEEN-HEALTHY", t:"Teen · Healthy Skin",
      d:"No active inflammatory condition to manage — no persistent breakouts, no widespread congestion, no irritation. The work here is protection and habit, not correction.",
      o:["Keep the barrier intact","Establish daily photoprotection","Prevent congestion before it starts"],
      a:["Niacinamide","Alpha arbutin","Bakuchiol","SPF 50"]},
    "CONGESTED":{c:"TEEN-CONGESTED", t:"Teen · Congested Pores",
      d:"Blackheads and whiteheads without the inflamed pimples of active acne. Comedones form when a pore blocks with oil and dead skin — congestion is the whole problem, so keeping the follicle open is the whole treatment.",
      o:["Normalise follicular keratinisation","Keep the follicle patent"],
      a:["Salicylic acid","Niacinamide","SPF 50"]},
    "MILD":{c:"TEEN-MILD", t:"Teen · Mild Breakouts",
      d:"Mostly congestion with the occasional pimple — between simple comedones and full active breakouts. Treated early, this is the grade least likely to leave a mark.",
      o:["Unclog the follicle","Prevent progression to inflammatory lesions"],
      a:["Salicylic acid","Niacinamide","Azelaic acid","SPF 50"]},
    "BREAKOUTS":{c:"TEEN-BREAKOUTS", t:"Teen · Breakouts",
      d:"Congested pores and inflamed pimples together — both the blackheads and whiteheads of congestion and the red, raised papules and pustules of inflammation.",
      o:["Unclog the follicle","Reduce inflammatory signalling","Limit post-inflammatory pigment"],
      a:["Salicylic acid","Niacinamide","Azelaic acid","SPF 50"]},
    "ACNE-1":{c:"TEEN-ACNE-1", t:"Teen · Acne Grade 1",
      d:"Mild acne — mostly comedones with a few small papules. The earliest grade, where congestion dominates and inflammation is minimal.",
      o:["Unclog the follicle","Keep inflammation from establishing"],
      a:["Salicylic acid","Niacinamide","SPF 50"]},
    "ACNE-2":{c:"TEEN-ACNE-2", t:"Teen · Acne Grade 2",
      d:"Moderate acne — more papules and pustules than the mildest grade, with noticeable inflammation alongside the congestion.",
      o:["Unclog the follicle","Reduce inflammatory signalling","Limit post-inflammatory pigment"],
      a:["Salicylic acid","Niacinamide","Azelaic acid","SPF 50"]},
    "ACNE-3":{c:"TEEN-ACNE-3", t:"Teen · Acne Grade 3",
      d:"More severe acne — widespread inflamed papules and pustules, some deeper nodules, visible redness. Inflammation is clearly the driver at this grade.",
      o:["Reduce inflammatory signalling","Unclog the follicle","Protect against scarring"],
      a:["Salicylic acid","Niacinamide","Azelaic acid","SPF 50"]},
    "ACNE-4":{c:"TEEN-ACNE-4", t:"Teen · Acne Grade 4",
      d:"Severe acne — extensive nodules and cysts, deep inflammation, high risk of scarring. This grade warrants medical referral alongside topical care.",
      o:["Reduce inflammatory signalling","Protect against scarring","Refer for medical assessment"],
      a:["Salicylic acid","Niacinamide","Azelaic acid","SPF 50"]},
    "FOLLICULITIS":{c:"TEEN-FOLLICULITIS", t:"Teen · Breakouts.Folliculitis",
      d:"Breakouts alongside folliculitis — small, uniform, often itchy pustules linked to Malassezia. Two pathways treated at once, because both are present.",
      o:["Reduce yeast load in the follicle","Unclog the follicle","Reduce inflammation"],
      a:["Zinc pyrithione","Salicylic acid","Niacinamide","SPF 50"]},
    "ALLERGY-D":{c:"TEEN-DRY-ALLERGY", t:"Teen · Dry Allergy",
      d:"Allergy-prone and running dry — reactive, prone to scaling, easily irritated. The barrier is the problem before anything else is.",
      o:["Repair the barrier first","Lower the reaction threshold"],
      a:["Niacinamide","d-Panthenol","Hyaluronic acid","SPF 50"]},
    "ALLERGY-O":{c:"TEEN-OILY-ALLERGY", t:"Teen · Oily Allergy",
      d:"Allergy-prone and oily at once — shiny on the surface, reactive underneath. Excess sebum to manage without provoking the reactivity.",
      o:["Regulate sebum without stripping","Lower the reaction threshold"],
      a:["Niacinamide","Zinc PCA","Azelaic acid","SPF 50"]}
  };

  function teenKey(){
    return state.teen.v === "ALLERGY"
      ? "ALLERGY-" + state.hyd.v      /* the only branch where hydration matters */
      : state.teen.v;
  }

  function renderTeen(pop){
    var key=teenKey(), f=teenFrag[key];
    var code=f.c;                       /* the real library code, not a derived one */
    out.classList.add("dxp-code--teen");
    /* group by hyphen so a long code wraps between words, never inside one */
    var n=0;
    out.innerHTML = code.split("-").map(function(seg,si,arr){
      var chars=(seg+(si<arr.length-1?"-":"")).split("").map(function(ch){
        var acc = si>0;                 /* 'TEEN' stays ink, the profile is copper */
        return '<span class="'+(acc?"acc":"")+(pop?" pop":"")+'" style="animation-delay:'+((n++)*26)+'ms">'+ch+'</span>';
      }).join("");
      return '<span class="dxp-code__seg">'+chars+'</span>';
    }).join("");
    tEl.textContent=f.t;
    dEl.textContent=f.d;
    oEl.textContent=f.o.join(" · ");
    aEl.textContent=f.a.join(" · ");
    setMore(code);
  }

  function render(pop){
    /* under twenty the architecture changes — different fields, different output */
    var young = state.age.v !== "adult";
    var pigF=doc.getElementById("lblPig"), infF=doc.getElementById("lblInf"),
        teenF=doc.getElementById("fieldTeen");
    if(pigF && pigF.closest) pigF.closest(".dxp-field").classList.toggle("dxp-field--off", young);
    if(infF && infF.closest) infF.closest(".dxp-field").classList.toggle("dxp-field--off", young);
    if(teenF) teenF.hidden = !young;
    if(young){ renderTeen(pop); return; }
    out.classList.remove("dxp-code--teen");

    var letters=["A", state.hyd.v, state.pig.v, state.inf.v].filter(Boolean).join("");
    out.innerHTML = letters.split("").map(function(ch,i){
      return '<span class="'+(i===0?"":"acc")+(pop?" pop":"")+'" style="animation-delay:'+(i*55)+'ms">'+ch+'</span>';
    }).join("");

    var words=["aging", state.hyd.w].concat(state.pig.w?[state.pig.w]:[]).concat(state.inf.w?[state.inf.w]:[]);
    tEl.textContent=words.join(".");

    var keys=["AGE", state.hyd.v].concat(state.pig.v?[state.pig.v]:[]).concat(state.inf.v?[state.inf.v]:[]);
    var ds=[], os=[], as=[];
    keys.forEach(function(k){
      var f=frag[k]; if(!f) return;
      ds.push(f.d); f.o.forEach(function(x){ if(os.indexOf(x)<0) os.push(x); });
      f.a.forEach(function(x){ if(as.indexOf(x)<0) as.push(x); });
    });
    dEl.textContent=ds.join(" ");
    oEl.textContent=os.join(" · ");
    aEl.textContent=as.join(" · ");
    setMore(letters);
  }

  /* barrier cards may target an adult-only field — let them switch pathway first */
  window.__dxpSetAdult=function(){
    var g=doc.querySelector('[data-group="age"]'); if(!g) return;
    var b=g.querySelector('[data-v="adult"]'); if(!b || b.classList.contains("on")) return;
    g.querySelectorAll(".dxp-opt").forEach(function(x){x.classList.remove("on");});
    b.classList.add("on");
    state.age={v:"adult",w:"adult"};
    render(true);
  };

  doc.querySelectorAll("[data-group]").forEach(function(g){
    var key=g.getAttribute("data-group");
    g.querySelectorAll(".dxp-opt").forEach(function(b){
      b.addEventListener("click",function(){
        g.querySelectorAll(".dxp-opt").forEach(function(x){x.classList.remove("on");});
        b.classList.add("on");
        state[key]={v:b.getAttribute("data-v"), w:b.getAttribute("data-w")};
        if(key==="age"){
          var h=doc.getElementById("builderHint");
          if(h){ h.classList.remove("on"); h.textContent=""; }
        }
        render(true);
      });
    });
  });
  render(false);
})();

/* ---------------------------------------------------------- BARRIER CARDS
   Each card is a <button>, so it has to do something. It jumps to the code
   builder, explains how that barrier enters the code, and pulses the field
   that controls it. -------------------------------------------------- */
(function(){
  var cards=Array.prototype.slice.call(doc.querySelectorAll("[data-barrier]"));
  if(!cards.length) return;
  var hint=doc.getElementById("builderHint"), builder=doc.querySelector(".dxp-builder");
  if(!builder) return;
  var map={
    aging:{g:null, t:"Above twenty, ageing is always present — it is the leading A in every adult code."},
    hydration:{g:"hyd", t:"Every adult code carries a hydration letter: D for dry, O for oily."},
    pigment:{g:"pig", t:"Pigmentation, where present, adds a P in the third position."},
    inflammation:{g:"inf", t:"The dominant inflammatory condition closes the code — B, BM, BF, R, A or S."}
  };
  var timer;
  cards.forEach(function(card){
    card.addEventListener("click",function(){
      var cfg=map[card.getAttribute("data-barrier")]; if(!cfg) return;
      /* pigment and the adult inflammation list only exist on the adult pathway */
      if((cfg.g==="pig"||cfg.g==="inf") && typeof window.__dxpSetAdult==="function") window.__dxpSetAdult();
      builder.scrollIntoView({behavior:reduced?"auto":"smooth", block:"center"});
      if(hint){ hint.textContent=cfg.t; hint.classList.add("on"); }
      doc.querySelectorAll(".dxp-field").forEach(function(f){ f.classList.remove("dxp-pulse"); });
      clearTimeout(timer);
      timer=setTimeout(function(){
        if(cfg.g){
          var grp=doc.querySelector('[data-group="'+cfg.g+'"]');
          var field=grp && grp.closest(".dxp-field");
          if(field){
            /* restart the animation reliably */
            field.classList.remove("dxp-pulse"); void field.offsetWidth; field.classList.add("dxp-pulse");
          }
        }
      }, reduced?0:420);
    });
  });
})();
})();